export default {
  getCampaign: state => state.campaign
}
